import * as React from 'react';

export type { ValidationPropType } from './use-validation';
export { useValidation } from './use-validation';

export type { TextFieldPropType } from './text';
export { useTextField } from './text';
export { useTextArea } from './text';

export type { CheckboxFieldPropType } from './checkbox';
export { useCheckboxField } from './checkbox';

export type { NumberFieldPropType } from './number';
export { useNumberField } from './number';

export type { SelectboxFieldPropType } from './selectbox';
export { useSelectBox } from './selectbox';

export function combineEventHandlers<TEvent extends React.SyntheticEvent<any>>(
  ...handlers: (React.EventHandler<TEvent> | undefined)[]
) {
  const combineEventHandler: React.EventHandler<TEvent> = (e: TEvent) => {
    for (const handler of handlers as React.EventHandler<TEvent>[]) {
      handler?.(e);
    }
  };
  return combineEventHandler;
}

export function useCombineEventHandlers<TEvent extends React.SyntheticEvent<any>>(
  ...handlers: (React.EventHandler<TEvent> | undefined)[]
) {
  return React.useMemo(
    () => combineEventHandlers(...handlers),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    handlers,
  );
}
